import React from 'react';
import './top-banner-ad.m.css';

const TopBannerAd = () => {
  return (
    <div className='top-banner-ad-container'>
      <div id='top-d' className='ad-slot incontent' />
      <div id='top-m' className='ad-slot incontent' />
    </div>
  );
};

export default TopBannerAd;
